/*
Sohel 03/21/2023 2699762545 Added letter Group Screen
Sohel 03/23/2023 2699762545 Added current letter in Group Screen
Sohel 03/24/2023 2699762545 Integrated letter in Group API
Sohel 03/27/2023 2699762545 Payload Changes
Dilip 03/27/2023 2699762545 added bredcrums to show code and description
Akhila 03/27/2023 2699762545 Added save button
Prakash 03/27/2023 2699762545 Added class name for table and removed unused div fields.
Sohel 03/28/2023 2699762545 Added Validation for letter group
Sohel 03/30/2023 2699762545 Change letter Type Value
Guru Prasad 04/03/2023 2699762545 Fixed column spacing issues
Sohel 04/08/2023 2699762545 Letter Group Payload Changes
Sohel 04/10/2023 3225736869 Fixed Letter Type Payload Changes
Prakash 11-04-23 2699762545 remove white space issue in letter maintainance
Guru Prasad 04/11/2023 2699762545 Fixed alignments
Ravi 04/12/2023 2699762545 Added unsaved popup changes
Akhila 05/24/2024 2699762545 role access implemeneted
Ravi 06/20/2023 2699762545 Added Breadcrum in popup
Ravi 06/20/2023 2699762545 removed Breadcrum in popup
Ravi 06/21/2023 2699762545 fixed submit issue
*/
import React, {useEffect, useState, useRef, useContext} from 'react';
import {Formik, FieldArray, Field} from 'formik';
import {Button, FormHelperText} from '@material-ui/core';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import * as Yup from 'yup';
import {
  fetchAllLetterGroupCode,
  fetchLetterCodeData,
  fetchLetterGroupData,
  postNewLetterGroup,
  resetBasicInfo,
  resetLetterGroup,
} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../components/DialogBox';
import AddLetterGroup from './AddLetterGroup';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';
import LetterGroupRecordTable from './LetterGroupRecordTable';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import BreadCrums from '../../../util/BreadCrum';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
const LetterGroup = ({
  handleBack,
  setValue,
  hidden,
  handleDirty,
  LetterMainAccess,
  editExisting,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [letterGroupCode, setLetterGroupCode] = useState('');
  const saveRef = useRef(false);
  const {
    letterCode,
    basicInfoStatus,
    allLetterGroupCode,
    isBasicInfoLoading,
    letterCodeData,
    basicInfoErrorMsg,
    basicInfoSuccessMsg,
    LetterGroupData,
    basicInfoData,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.letterGroupCode === option) {
          label = item;
        }
      });
    return label;
  };
  const initialState = {
    letterGroup: LetterGroupData?.letterGroupCode ?
      getObject(LetterGroupData?.letterGroupCode, allLetterGroupCode) :
      '',
    groupRecords: [],
  };
  const [initialValues, setInitialValues] = useState(initialState);

  const dispatch = useDispatch();
  const handleClose = () => {
    setIsOpen(false);
  };
  const dmArrayHelpers = useRef();
  const formRef = useRef();
  const reorderItems = (startIndex, endIndex) => {
    const {values, setFieldValue} = dmArrayHelpers?.current?.form;
    const arr = [...values.groupRecords];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    setFieldValue('groupRecords', arr);
  };
  const onDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        if (basicInfoSuccessMsg && basicInfoStatus === 200 && !saveRef.current) {
          setValue(0);
        } else if (basicInfoSuccessMsg && basicInfoStatus === 200 && saveRef.current) {
          const letterType = basicInfoData?.letterType?.replace(' ', '_');
          dispatch(fetchAllLetterGroupCode(letterType));
        }
        dispatch(resetBasicInfo());
      }, 2000);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg, basicInfoStatus]);
  const columns = [
    {
      title: 'SeqNo',
    },
    {
      title: 'Letter Code',
    },
    {
      title: 'Letter Description',
    },
  ];
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const allLetterCode =
      values?.groupRecords?.length > 0 ?
        values?.groupRecords?.map((el, index) => {
          return {
            letterCode: el?.letterCode,
            letterDescription: el?.letterDescription,
            letterGroupCode: values?.letterGroup?.letterGroupCode,
            letterGroupItemsId: el?.letterGroupItemsId ? el?.letterGroupItemsId : 0,
            seqNo: index + 1,
          };
        }) :
        [];
    const payload = {
      deleteIds: [0],
      isDraft: 'N',
      lastStep: hidden ?
        basicInfoData?.lastStep > 6 ?
          basicInfoData?.lastStep :
          6 :
        basicInfoData?.lastStep > 7 ?
          basicInfoData?.lastStep :
          7,
      letterType: basicInfoData?.letterType ? basicInfoData?.letterType : '',
      letterGroupCode: values?.letterGroup?.letterGroupCode ?
        values?.letterGroup?.letterGroupCode :
        '',
      letterGroupDescription: values?.letterGroup?.letterGroupDescription ?
        values?.letterGroup?.letterGroupDescription :
        '',
      letterGroupItemResponse: allLetterCode,
      letterCode: letterCode,
    };

    dispatch(postNewLetterGroup(payload));
  };

  useEffect(() => {
    const letterType = basicInfoData?.letterType?.replace(' ', '_');
    dispatch(fetchAllLetterGroupCode(letterType));
  }, []);

  useEffect(() => {
    if (letterCodeData?.letterGroupItemResponse?.length) {
      const letterValues = [...letterCodeData?.letterGroupItemResponse];
      if (
        LetterGroupData?.letterGroupCode !== formRef.current?.values?.letterGroup?.letterGroupCode
      ) {
        letterValues.push({
          letterCode: basicInfoData?.letterCode ? basicInfoData?.letterCode : '',
          letterDescription: basicInfoData?.letterDescription ?
            basicInfoData?.letterDescription :
            '',
          letterGroupCode: formRef.current?.values?.letterGroup?.letterGroupCode ?
            formRef.current?.values?.letterGroup?.letterGroupCode :
            '',
          letterGroupItemsId: 0,
        });
      }

      const data = letterValues?.map((el) => {
        return {
          ...el,
          letterCode: el?.letterCode,
          letterDescription: el?.letterDescription,
        };
      });
      setInitialValues({
        ...initialState,
        letterGroup:
          getObject(formRef.current?.values?.letterGroup?.letterGroupCode, allLetterGroupCode) ||
          {},
        groupRecords: data,
      });
    } else if (formRef.current?.values?.letterGroup?.letterGroupCode) {
      setInitialValues({
        ...initialState,
        letterGroup:
          getObject(formRef.current?.values?.letterGroup?.letterGroupCode, allLetterGroupCode) ||
          {},
        groupRecords: [
          {
            letterCode: basicInfoData?.letterCode ? basicInfoData?.letterCode : '',
            letterDescription: basicInfoData?.letterDescription ?
              basicInfoData?.letterDescription :
              '',
            letterGroupCode: formRef.current?.values?.letterGroup?.letterGroupCode ?
              formRef.current?.values?.letterGroup?.letterGroupCode :
              '',
            letterGroupItemsId: 0,
          },
        ],
      });
    } else {
      setInitialValues({
        ...initialState,
        letterGroup:
          getObject(formRef.current?.values?.letterGroup?.letterGroupCode, allLetterGroupCode) ||
          {},
        groupRecords: [],
      });
    }
  }, [letterCodeData]);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  useEffect(() => {
    if (letterGroupCode) {
      dispatch(fetchLetterCodeData(letterGroupCode));
      setInitialValues({
        ...initialState,
        letterGroup: getObject(letterGroupCode, allLetterGroupCode) || {},
        groupRecords: [],
      });
    } else {
      setLetterGroupCode('');
    }
  }, [letterGroupCode, allLetterGroupCode]);
  useEffect(() => {
    if (LetterGroupData?.letterGroupCode) {
      dispatch(fetchLetterCodeData(LetterGroupData?.letterGroupCode));
      setInitialValues({
        ...initialState,
        letterGroup: getObject(LetterGroupData?.letterGroupCode, allLetterGroupCode) || {},
        groupRecords: [],
      });
    }
  }, [LetterGroupData]);
  useEffect(() => {
    if (letterCode) {
      dispatch(fetchLetterGroupData(letterCode));
    }
  }, [letterCode]);

  const validationSchema = Yup.object().shape({
    letterGroup: Yup.mixed().test('letterGroup', 'Letter Group is required', (value) => {
      if (!value?.letterGroupCode) {
        return false;
      } else {
        return true;
      }
    }),
  });

  return (
    <>
      <DialogBox
        open={isOpen}
        dialogClose={handleClose}
        title={'Add New Letter Group'}
        maxWidth="md"
      >
        <AddLetterGroup
          handleClose={handleClose}
          setLetterGroupCode={setLetterGroupCode}
          saveRef={saveRef}
        />
      </DialogBox>
      <div className="mb-2">
        <BreadCrums
          name={'Letter Code'}
          code={basicInfoData?.letterCode}
          description={'Letter Description'}
          descriptionValue={basicInfoData?.letterDescription}
        />
      </div>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleReset,
            handleSubmit,
            submitForm,
            setFieldValue,
          } = props;
          if (LetterGroupData?.letterGroupCode !== values?.letterGroup?.letterGroupCode) {
            handleDirty(true);
          } else {
            handleDirty(false);
          }
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row mt-3 standard-field-textfields new-standard-textfields">
                <div className={` col-md-5 col-lg-4 col-xl-3 form-group`}>
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="letterGroup"
                    id="letterGroup"
                    size="small"
                    options={allLetterGroupCode || []}
                    value={values.letterGroup}
                    autoHighlight
                    getOptionLabel={(option) => {
                      return option?.letterGroupCode ?
                        option?.letterGroupCode + ' -' + option?.letterGroupDescription :
                        '';
                    }}
                    onChange={(e, value) => {
                      setFieldValue('letterGroup', value);
                      dispatch(resetLetterGroup());
                      setLetterGroupCode('');
                      if (value?.letterGroupCode) {
                        dispatch(fetchLetterCodeData(value?.letterGroupCode));
                      }
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={`${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          label="Letter Group"
                          placeholder="Select Letter Group"
                          touched={touched.letterGroup}
                          error={touched.letterGroup && errors.letterGroup}
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.letterGroup && errors?.letterGroup && errors.letterGroup}
                  </FormHelperText>
                </div>
                <div>
                  <Button
                    variant="outlined"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    disabled={editExisting && !LetterMainAccess?.edit}
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    <AddIcon />
                    Add New Letter Group
                  </Button>
                </div>
              </div>
              <div>
                <FieldArray
                  name="groupRecords"
                  render={(arrayHelpers) => {
                    dmArrayHelpers.current = arrayHelpers;
                    return (
                      <>
                        {/* <div className="table-header justify-content-between">
                          <div></div>
                        </div> */}
                        <div
                          className={
                            'new-standard-textfields mui-custom-table-container custom-table  pt-0 global-field-table text-center-table'
                          }
                        >
                          <DragDropContext onDragEnd={onDragEnd}>
                            <table>
                              <thead className="recFormat-header-container">
                                <tr>
                                  {columns.map(
                                    ({title, hidden = false}) =>
                                      !hidden && (
                                        <th key={title} className="recFormat-header">
                                          {title}
                                        </th>
                                      ),
                                  )}
                                </tr>
                              </thead>

                              <Droppable droppableId="droppabe-list">
                                {(provided) => (
                                  <tbody ref={provided.innerRef} className="recFormat-body">
                                    {values.groupRecords?.length > 0 ? (
                                      values.groupRecords?.map((rowData, index) => {
                                        return (
                                          <Field
                                            key={index}
                                            name={'groupRecords[' + index + ']'}
                                            component={LetterGroupRecordTable}
                                            index={index}
                                            columns={columns}
                                            dmArrayHelpers={dmArrayHelpers}
                                          />
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td colSpan={columns.length}>
                                          No records to display. To add records to your record group
                                          click the &quot;Add New Letter Group&quot; button in the top right
                                          of this section.
                                        </td>
                                      </tr>
                                    )}
                                    {provided.placeholder}
                                  </tbody>
                                )}
                              </Droppable>
                            </table>
                          </DragDropContext>
                        </div>
                      </>
                    );
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mt-3  new-standard-textfields">
                <Button
                  variant="outlined"
                  className={`mr-1 reset-btn`}
                  onClick={() => {
                    handleReset();
                    handleBack();
                  }}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                  onClick={() => {
                    submitForm();
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  type="button"
                  variant="outlined"
                  className={`ml-1 search-btn`}
                  disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                  onClick={() => {
                    saveRef.current = false;
                    submitForm();
                  }}
                >
                  Finish
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
};

export default LetterGroup;
